import * as React from "react";
import { CheckboxOnChange } from "./Checkbox";

interface CheckboxRadioGroupProps {
    selectedName?: string;
    onSelect: (name: string) => void;
}

interface CheckboxRadioGroupContextProps {
    selectedName?: string;
    onChange?: CheckboxOnChange;
}

export const CheckboxRadioGroupContext = React.createContext<CheckboxRadioGroupContextProps>(null);

export class CheckboxRadioGroup extends React.Component<CheckboxRadioGroupProps> {
    onChange: CheckboxOnChange = (newValue, name) => {
        this.props.onSelect(name);
    };

    render() {
        const { children, selectedName } = this.props;
        return (
            <CheckboxRadioGroupContext.Provider value={{ selectedName, onChange: this.onChange }}>
                {children}
            </CheckboxRadioGroupContext.Provider>
        );
    }
}
